<template>
  <div class="power-data">
    <div
      :class="'breaker-data-' + breakerNum"
      class="real-data"
    >
      <div class="tit">
        {{currentLoop.name}}
      </div>
      <div class="quantity row-center" v-if="routeName === 'Classification'" v-loading="loading">
        <div class="item column-center item1" :class="'bg'+(index+1)" v-for="(item,index) in electricityData" >
          <div v-if="currentLoop.id==30">
            <div class="title">{{item.title}}</div>
            <div class="info">用电量：<span>{{item.electricity}}kWh</span></div>
            <div class="info">用水量：<span>{{item.water}}m³</span></div>
            <div class="info">用热量：<span>{{item.heat}}GJ</span></div>
            <!-- <div class="info">用冷量：<span>{{item.cooling}}GJ</span></div> -->
          </div>
          <div class="newclass" v-else>
            <div class="title">{{item.title}}</div>
            <div class="info">用电量：<span>{{item.electricity}}kWh</span></div>
          </div>
          <!-- <div v-else>
            <div class="title">{{item.title}}</div>
            <div class="info">用电量：--</div>
            <div class="info">用水量：--</div>
            <div class="info">用热量：--</div>
            <div class="info">用冷量：--</div>
          </div> -->
        </div>
      </div>
      <div class="quantity Suboption row-center" v-else  v-loading="itemloading">
        <div class="item column-center item2" :class="'bg1'+index" v-for="(item,index) in itemData" >
          <div class="title">{{item.title}}</div>
          <div class="info">日：<span>{{item.day}}{{item.unit}}</span></div>
          <div class="info">周：<span>{{item.week}}{{item.unit}}</span></div>
          <div class="info">月：<span>{{item.month}}{{item.unit}}</span></div>
          <div class="info">年：<span>{{item.year}}{{item.unit}}</span></div>
        </div>
      </div>
    </div>
    <div
      v-if="breakerNum === 0"
      class="diagram"
      :class="{ transformerClass: routeName === 'Transformer' }"
    >
      <div
        v-if="routeName === 'Breaker'"
        class="select row-center"
        style="justify-content: flex-start"
      >
        <el-checkbox
          style="margin-top: 14rem"
          label="切换为数据列表"
          name="type"
          @change="diagramSelected = diagramSelected === 0 ? 1 : 0"
        ></el-checkbox>
      </div>
      <div v-else class="select row-center" style="justify-content: flex-start">
        <div
          :class="{ active: diagramSelected === 0 }"
          @click="diagramSelected = 0"
        >
          历史曲线
        </div>
        <div
          :class="{ active: diagramSelected === 1 }"
          @click="diagramSelected = 1"
        >
          数据列表
        </div>
      </div>
      <div
        class="content row-center"
        style="justify-content: space-between;padding-right: 24px;"
      >
        <div class="row-center">
          <div style="display: inline-block;">
            <el-date-picker
            :editable="false"
            :picker-options="pickerOptions"
            :clearable="false"
            class="dateSelect"
            v-model="date"
            :key="radio === 'day' ? 'date' : radio"
            :format="radio === 'week'?'yyyy 第 WW 周':''"
            :type="radio === 'day' ? 'date' : radio"
            :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
          >
          </el-date-picker>
          </div>
          <el-radio v-model="radio" label="year">年</el-radio>
          <el-radio v-model="radio" label="month">月</el-radio>
          <el-radio v-model="radio" label="week">周</el-radio>
          <el-radio v-model="radio" label="day">日</el-radio>
          <div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
          <div class="btn per" @click="perM" v-if="radio === 'month'">
            上一月
          </div>
          <div class="btn per" @click="perW" v-if="radio === 'week'">
            上一周
          </div>
          <div class="btn per" @click="perY" v-if="radio === 'year'">
            上一年
          </div>
          <el-button
            class="btn next"
            plain
            @click="nextD"
            :disabled="nextDayDisabled"
            v-if="radio === 'day'"
            >下一日</el-button
          >
          <el-button
            class="btn next"
            plain
            @click="nextM"
            v-if="radio === 'month'"
            :disabled="nextDayDisabled"
          >
            下一月
          </el-button>
          <el-button
            class="btn next"
            plain
            @click="nextW"
            v-if="radio === 'week'"
            :disabled="nextDayDisabled"
          >
            下一周
          </el-button>
          <el-button
            class="btn next"
            plain
            @click="nextY"
            v-if="radio === 'year'"
            :disabled="nextDayDisabled"
            >下一年
          </el-button>
          <el-select class="node-select" v-model="node" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="row-center">
          <div class="max">
            <el-checkbox
              v-if="diagramSelected === 0"
              label="最值分析"
              name="type"
              v-model="showMax"
            >
            </el-checkbox>
          </div>
          <div class="export ">
            <img
              style="width: 14px; height: 14px"
              src="../../assets/img/export.png"
            />
            <span
              v-show="diagramSelected === 0"
              style="font-size: 14px; cursor: pointer"
              @click="exportFunc"
              >导出图表</span
            >
            <span
              v-show="diagramSelected === 1"
              style="font-size: 14px; cursor: pointer"
              @click="exportFunc"
              >导出报表</span
            >
          </div>
        </div>
      </div>
      <div
        class="echarts row-center"
        style="justify-content: space-between"
        :class="{ showMax }"
        v-if="diagramSelected === 0"
      >
        <div class="left row-center" style="margin-top:20rem">
          <Curve
            v-if="diagramData&&canvasShow"
            :chartsData="diagramData"
          ></Curve>
          <img v-else src="../../assets/img/not_found_data.png" alt="" />
        </div>
        <div
          v-show="showMax"
          class="max-right row-center"
          style="justify-content: space-between"
          v-if="diagramData"
        >
          <div
            class="row-max row-center"
            style="justify-content: space-between"
            v-for="(item, index) in diagramData.legend.data"
            :key="index"
          >
            <div class="max-name row-center">{{ item }}</div>
            <div
              class="details column-center"
              style="justify-content: space-evenly"
            >
              <div
                class="row-center"
                style="width: 100%; justify-content: flex-start"
              >
                <span>最大值</span><span>{{ max(item) }}</span
                ><span></span>
              </div>
              <div
                class="row-center"
                style="width: 100%; justify-content: flex-start"
              >
                <span>最小值</span><span>{{ min(item) }}</span
                ><span></span>
              </div>
              <div
                class="row-center"
                style="width: 100%; justify-content: flex-start"
              >
                <span>平均值</span><span>{{ average(item) }}</span
                ><span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab row-center" v-show="diagramSelected === 1 && tshow">
        <el-table
          v-if="tableData.length > 0 && tshow"
          :height="routeName !== 'Transformer' ? '480rem' : '430rem'"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="name" label="名称" min-width="130">
          </el-table-column>
          <el-table-column
            prop="time"
            label="采集时间"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
              prop="val"
              :label="selectLabel"
              min-width="100"
            >
            </el-table-column>
        </el-table>
        <img v-else src="../../assets/img/not_found_data.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import Curve from "../../chart/Curve";
import {
  BuildingRange,
  classifiedEnergyConsumption,
  ItemEnergyConsumption,
  BuildingItem
} from "../../api/power";
import { floatFormat } from "../../util/MathUtil";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate,
  getDiffDate,
  weekStart,
  weekEnd
} from "../../util/DateUtil";
import exportExcel from "../../util/excel";
export default {
  name: "PowerDataBase",
  props: {
    realData: Array,
    options: Array,
    currentLoop: Object,
    selectedLoops: Array,
  },
  components: {
    Curve,
  },
  data() {
    let that = this;
    return {
      tshow: true,
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      breakerNum:0,
      radio: "month",
      canvasShow: true,
      showMax: false,
      node: "electricity",
      date: new Date(),
      diagramSelected: 0,
      diagramData: null,
      electricity:{},
      electricityData:[],
      itemMap:{},
      itemData:[],
      loading:true,
      itemloading:true
    };
  },
  computed: {
    // 组合tag和routeName 变化时触发watch: routeNameAndTag
    routeNameAndTag() {
      return [this.routeName, this.tag];
    },
    changeData(){
      return [this.date,this.node]
    },
    //路由名称
    routeName() {
      return this.$route.params.name;
    },
    //路由tag
    tag() {
      return this.$route.params.tag;
    },
    //select选择的label
    selectLabel() {
      return this.options.filter((item) => item.value === this.node)[0].label;
    },
    getunit() {
      return this.options.filter((item) => item.value === this.node)[0].unit;
    },
    //table数据
    tableData() {
      let obj = []
      if(this.diagramData&&this.diagramData.xAxis.data.length!=0){
        let array = this.diagramData.xAxis.data
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          let item = {
            title:this.diagramData.series[0].name,
            name:this.currentLoop.name,
            time:dateFormat("YY/mm/dd",this.date)+" "+(index<10?'0'+index:index)+":00:00",
            val:this.diagramData.series[0].data[index]==null?"--":Number(this.diagramData.series[0].data[index]).toFixed(2)
          }
          if(this.radio=='month'){
            item.time = dateFormat("YY/mm",this.date)+"/"+((index+1)<10?'0'+(index+1):(index+1))
          }
          if(this.radio=='year'){
            item.time = dateFormat("YY",this.date)+"/"+((index+1)<10?'0'+(index+1):(index+1))
          }
          if(this.radio=='week'){
            item.time = element.replaceAll('-','/')
          }
          obj.push(item)
        }
        return obj
      }else{
        return []
      }
      
    },
    min() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (data[0].data.length === 0||data[0].data.filter((e)=>e!=null).length === 0) {
          return "--";
        }
        let minValue = Math.min(...data[0].data);
        let minTimeIndex = data[0].data.findIndex((item) => item == minValue);
        let minTime = this.diagramData.xAxis.data[minTimeIndex];
        return (
          floatFormat(Math.min(...data[0].data), 2) +
          ` (${this.formateTime(minTime)})`
        );
      };
    },
    //平均值
    average() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (data[0].data.length === 0||data[0].data.filter((e)=>e!=null).length === 0) {
          return "--";
        }
        let sum = 0;
        data[0].data.forEach((e) => (sum += +e));
        return floatFormat(sum / data[0].data.length, 2);
      };
    },
    max() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (data[0].data.length === 0||data[0].data.filter((e)=>e!=null).length === 0) {
          return "--";
        }
        let maxValue = Math.max(...data[0].data);
        let maxTimeIndex = data[0].data.findIndex((item) => item == maxValue);
        let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
        return (
          floatFormat(Math.max(...data[0].data), 2) +
          ` (${this.formateTime(maxTime)})`
        );
      };
    },
    mqttval() {
      return this.getMqttVal(this.$store.getters.mqttVal);
    },
    getMqttMaxVal() {
      return this.getMqttVal(this.$store.getters.mqttMaxVal);
    },
    getMqttMeanVal() {
      return this.getMqttVal(this.$store.getters.mqttMeanVal);
    },
    getMqttMinVal() {
      return this.getMqttVal(this.$store.getters.mqttMinVal);
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      }else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date,5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
  },
  mounted() {
    this.nextDayDisabled;
    if(this.routeName == "Suboption"){
      this.node = "AIR_CONDITIONER";
      this.GetBuildingItem();
      this.canvasDataRultItem();
    }else{
      this.GetBuildingRange();
      this.canvasDataRult();
    }
  },
  watch: {
    currentLoop(n, o) {
      if(this.routeName == "Classification"){
        this.GetBuildingRange();
        this.canvasDataRult();
      }else{
        this.GetBuildingItem();
        this.canvasDataRultItem();
      }
    },
    tag(n, o) {
      this.initPowerTimeData();
    },
    changeData(){
      if(this.routeName == "Classification"){
        this.canvasDataRult();
      }else{
        this.canvasDataRultItem();
      }
    },
    diagramSelected() {
      this.reload();
    },
    radio(n) {
      this.date = new Date();
    },
    showMax(n, o) {
      this.reload();
    },
  },
  methods: {
    //分项能耗
    async canvasDataRultItem(){
      let range = this.radio;
      let node = this.node
      let obj ={
         buildingId:this.currentLoop.id,
         date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
         itemType:node.toUpperCase(),
         range:range.toUpperCase()
      }
      let response = await ItemEnergyConsumption(obj);
      let xAxisData = [];
      if(this.radio=="year"){
        for (let i = 1; i <= 12; i++) {
          xAxisData.push(i  + "月");
        }
      }else if(this.radio=="month"){
        for (let i = 1; i <= 31; i++) {
          xAxisData.push(i  + "日");
        }
      }else if(this.radio=="week"){
        let startDate = weekStart(this.date).replace('T00:00:00Z',"")
        let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
        let time = getDiffDate(startDate,endDate)
        for (let i = 0; i < time.length; i++) {
            xAxisData.push(time[i])
        }
      }else if(this.radio=="day"){
        for (let i = 0; i < 24; i++) {
          xAxisData.push(i  + "点");
        }
      }
      if(response.data.code!=200){
        this.canvasShow = false;
        this.diagramData = false
        return
      }
      let data = response.data.data.result
      data = data.map((e)=>{
        return e==null?"":e.toFixed(2)
      })
      if(data.length<=0||data.filter((e)=>e!=null&&e!="").length<=0){
        this.canvasShow = false;
        this.diagramData = false
        return
      }
      
      let seriesData = [
        {
          data: data,
          type: 'line',
          name:this.selectLabel,
          smooth: true,
          areaStyle: {
            color: "rgba(13, 148, 255, 0.3)",
          }
        }
      ]
      let legendTitle = [this.selectLabel]
      this.$set(
          this,
          "diagramData",
          this.createCanvasData(legendTitle,xAxisData, seriesData)
        );
    },
    //曲线
    async canvasDataRult(){
      let range = this.radio;
      let node = this.node
      let obj ={
         buildingId:this.currentLoop.id,
         date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
         powerType:node.toUpperCase(),
         range:range.toUpperCase()
      }
      let response = await classifiedEnergyConsumption(obj);
      let xAxisData = [];
      if(this.radio=="year"){
        for (let i = 1; i <= 12; i++) {
          xAxisData.push(i  + "月");
        }
      }else if(this.radio=="month"){
        for (let i = 1; i <= 31; i++) {
          xAxisData.push(i  + "日");
        }
      }else if(this.radio=="week"){
        let startDate = weekStart(this.date).replace('T00:00:00Z',"")
        let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
        let time = getDiffDate(startDate,endDate)
        for (let i = 0; i < time.length; i++) {
            xAxisData.push(time[i])
        }
      }else if(this.radio=="day"){
        for (let i = 0; i < 24; i++) {
          xAxisData.push(i  + "点");
        }
      }
      let data = response.data.data.result[this.node]
      data = data.map((e)=>{
        return e==null?"":e.toFixed(2)
      })
      if(data.length<=0||data.filter((e)=>e!=null&&e!="").length<=0){
        this.canvasShow = false;
        this.diagramData = false
        return
      }
      
      let seriesData = [
        {
          data: data,
          type: 'line',
          name:this.selectLabel,
          smooth: true,
          areaStyle: {
            color: "rgba(13, 148, 255, 0.3)",
          }
        }
      ]
      let legendTitle = [this.selectLabel]
      this.$set(
          this,
          "diagramData",
          this.createCanvasData(legendTitle,xAxisData, seriesData)
        );
    },
    createCanvasData(legendTitle, xAxisData, seriesData) {
      this.canvasShow = false;
      let color = ["#0D94FF"];
      this.canvasShow = true;
      return {
        color,
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: "18rem",
          },
          data:legendTitle,
          itemGap: 20,
        },
        grid: {
          left: 50,
          right: 50,
          bottom: "5%",
          containLabel: true
        },
        toolbox: {
          feature: {
            //saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: xAxisData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#CCCCCC",
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#999999",
            },
          },
        },
        yAxis:{
        	type:"value",
          name:this.getunit
        },
        series:seriesData,
      };
    },
    //用电量
    async GetBuildingRange(){
      this.loading = true
      this.electricityData = []
      let response = await BuildingRange({buildingId:this.currentLoop.id});
      this.electricity = response.data.data.power;
      this.GetelectricityData();
    },
    //分项能耗
    async GetBuildingItem(){
      this.itemloading = true
      this.itemMap = [];
      let response = await BuildingItem({buildingId:this.currentLoop.id});
      this.itemMap = response.data.data.power;
      this.GetItemData();
    },
    GetelectricityData(){
      // this.electricityData = [
      //   {
      //   title:"用电量",
      //   day:this.electricity.electricity.day.toFixed(2),
      //   month:this.electricity.electricity.month.toFixed(2),
      //   week:this.electricity.electricity.week.toFixed(2),
      //   year:this.electricity.electricity.year.toFixed(2),
      //   unit:"kWh"
      // },
      // {
      //   title:"用水量",
      //   day:this.electricity.water.day.toFixed(2),
      //   month:this.electricity.water.month.toFixed(2),
      //   week:this.electricity.water.week.toFixed(2),
      //   year:this.electricity.water.year.toFixed(2),
      //   unit:"m³"
      // },
      // {
      //   title:"用热量",
      //   day:this.electricity.heat.day.toFixed(2),
      //   month:this.electricity.heat.month.toFixed(2),
      //   week:this.electricity.heat.week.toFixed(2),
      //   year:this.electricity.heat.year.toFixed(2),
      //   unit:"GJ"
      // },
      // {
      //   title:"用冷量",
      //   day:this.electricity.cooling.day.toFixed(2),
      //   month:this.electricity.cooling.month.toFixed(2),
      //   week:this.electricity.cooling.week.toFixed(2),
      //   year:this.electricity.cooling.year.toFixed(2),
      //   unit:"GJ"
      // },
      // ]
      this.electricityData = [
        {
        title:"日",
        electricity:this.electricity.electricity.day.toFixed(2),
        water:this.electricity.water.day.toFixed(2),
        heat:this.electricity.heat.day.toFixed(2),
        cooling:this.electricity.cooling.day.toFixed(2),
        unit:"kWh"
      },
      {
        title:"周",
        electricity:this.electricity.electricity.week.toFixed(2),
        water:this.electricity.water.week.toFixed(2),
        heat:this.electricity.heat.week.toFixed(2),
        cooling:this.electricity.cooling.week.toFixed(2),
        unit:"m³"
      },
      {
        title:"月",
        electricity:this.electricity.electricity.month.toFixed(2),
        water:this.electricity.water.month.toFixed(2),
        heat:this.electricity.heat.month.toFixed(2),
        cooling:this.electricity.cooling.month.toFixed(2),
        unit:"GJ"
      },
      {
        title:"年",
        electricity:this.electricity.electricity.year.toFixed(2),
        water:this.electricity.water.year.toFixed(2),
        heat:this.electricity.heat.year.toFixed(2),
        cooling:this.electricity.cooling.year.toFixed(2),
        unit:"GJ"
      },
      ]
      this.loading = false
    },
    //分项能耗
    GetItemData(){
       this.itemData = []
      for (let item in this.itemMap) {
        this.itemData.push({
          title:item,
          day:this.itemMap[item].day.toFixed(2),
          month:this.itemMap[item].month.toFixed(2),
          week:this.itemMap[item].week.toFixed(2),
          year:this.itemMap[item].year.toFixed(2),
          unit:"kWh"
        })
      }
      this.itemloading = false
    },
    formateTime(string) {
      if(this.radio!="day"){
        return string
      }else{
        let array = string.split("");
        array.pop();
        if (array.length < 2) {
          return "0" + array[0] + ":00";
        } else {
          return array.join("") + ":00";
        }
      }
      
    },
    exportFunc() {
      if (!this.diagramData.xAxis.data.length) {
        this.$message.warning("无图表数据！");
        return;
      }
      if (this.diagramSelected === 0) {
        this.$store.commit("exportDiagram", {
          type: "echarts",
          version: Math.random(),
        });
      } else {
        let data = [["名称", "采集时间",this.selectLabel]];
        this.tableData.forEach((d) => {
          let map = []
          for (let k in d) {
            if(k!="title"){
              map.push(d[k]);
            }
          }
          data.push(map)
        });

        let name = "";
        if (this.routeName === "Classification" && this.tag === "none") {
          name = "分类能耗";
        } 
        exportExcel(data, name, []);
      }
    },
    reload() {
      this.canvasShow = !this.canvasShow;
      this.$nextTick(() => {
        this.canvasShow = !this.canvasShow;
      });
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
    perW(){
      let week = getAppointedDate(this.date,1, 1)
      this.date = new Date(week.startDate);
    },
    nextW(){
      let week = getAppointedDate(this.date,1,-1)
      this.date = new Date(week.startDate);
    },
  },
};
</script>

<style scoped lang="less">
.newclass{
  margin-top: -14px;
  .info{
    font-size: 22rem !important;
    line-height: 90px !important;
    text-align: center !important;
    padding: 0 !important;
    padding-top: 21px !important;
  }
}
.quantity {
  justify-content: space-between;
  margin-top: 15rem;
  height: 23vh;
  .item1 .info{
    text-align: left;
    padding-left: 23%;
  }
  .item2 .info{
    text-align: left;
    padding-left: 33%;
  }  .item {
    &>div{
      width: 100%;
    }
    background: rgba(246, 189, 22, 0.08);
    font-weight: bold;
    width: 15.4vw;
    border-radius: 24rem;
    height: 23vh;
    text-align: center;
    .title {
      font-size: 24rem;
      line-height: 6vh;
    }
    .info {
      font-size: 18rem;
      width: 100%;
      border-top: 1px solid rgba(0, 43, 102, 0.15);
      line-height: 4vh;
      
      span {
        color: #0d94ff;
      }
    }
  }
  .bg1{
    background: rgba(246, 189, 22, 0.08);
    // background: url('../../assets/img/bg1.png') center no-repeat rgba(246, 189, 22, 0.08);
  }
  .bg2{
    background: rgba(109, 200, 236, 0.08);
    // background: url('../../assets/img/bg2.png') center no-repeat rgba(109, 200, 236, 0.08);
  }
  .bg3{
    background: rgba(232, 104, 74, 0.08);
    // background: url('../../assets/img/bg3.png') center no-repeat rgba(232, 104, 74, 0.08);
  }
  .bg4{
    background: rgba(146, 112, 202, 0.08);
    // background: url('../../assets/img/bg4.png') center no-repeat rgba(146, 112, 202, 0.08);
  }
  .bg10{
    background: url('../../assets/img/bg5.png') center no-repeat rgba(13, 148, 255, 0.04);
  }
  .bg11{
    background: url('../../assets/img/bg6.png') center no-repeat rgba(13, 148, 255, 0.04);
  }
  .bg12{
    background: url('../../assets/img/bg7.png') center no-repeat rgba(13, 148, 255, 0.04);
  }
}
.Suboption{
  .item{
    width: 20.4vw !important;
  }
}
.loadfactor {
  width: 120rem;
  text-align: center;
}
.el-dropdown-menu__item.active {
  color: #0d94ff;
}
.breaker-data-1 {
  .h(968) !important;
}

.tab-breaker {
  > div {
    font-size: 18rem;
    font-weight: 400;
    color: #999999;
    border-top: 2px solid #ffffff;
    padding-top: 23rem;
    margin-right: 25rem;

    &.active {
      font-weight: bold;
      color: #0d94ff;
      border-top: 2px solid rgba(13, 148, 255, 1);
    }
  }
}

.transformerClass {
  .h(570) !important;

  .echarts {
    .left {
      .h(400) !important;
    }
  }

  .max-right {
    .h(400) !important;
  }
}

.transformer-data {
  padding: 0 24rem;
  background-color: #fff;
  .h(389);

  .card-list {
    .card-item {
      .w(298);
      .h(254);
      padding: 0rem 24rem;
      border-radius: 4px;
      background-color: rgba(0, 43, 102, 0.04);
      position: relative;

      h5 {
        font-size: 18rem;
        font-weight: 400;
        color: #333333;
      }

      span {
        font-size: 24rem;
        font-weight: bold;
        color: #0d94ff;
        // margin-top: 8rem;
      }

      .val-details {
        width: 100%;
        justify-content: space-between;
        // margin-top: 20rem;

        span {
          font-size: 16rem;
          font-weight: 400;
          color: #999999 !important;
        }
      }
    }

    .type-2 {
      // padding-top: 70rem;
      span {
        margin-top: 25rem;
      }
    }

    .type-3 {
      align-items: flex-start;
      padding: 0 20rem;

      h4 {
        font-size: 24px;
        font-weight: bold;
        color: #f5aa00;
      }

      h5.sub-title {
        font-size: 17rem;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
      }

      p {
        font-size: 14rem;
        color: rgba(153, 153, 153, 1);
      }

      h5,
      p {
        line-height: 32rem;
      }
    }

    .type-4 {
      // padding-bottom: 12px;

      .other {
        span {
          font-size: 16rem;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .type-1 .column-center,
    .type-4 .column-center {
      height: 90rem;
      // width: 100%;
    }

    .type-1 .column-center:first-child,
    .type-4 .column-center:first-child {
      // height: 135rem;
      // padding-top: 20rem;
      // justify-content: initial;
      // width: 100%;
    }

    .other {
      position: absolute;
      bottom: 12rem;
    }
  }

  .tab {
    span {
      display: inline-block;

      min-width: 88rem;
      line-height: 64rem;
      border-top: 2px solid #ffffff;
      font-size: 18rem;
      text-align: center;
      margin-right: 29rem;
      transition: all 0.3s;
      font-weight: 400;
      color: #999999;

      &.active {
        border-top: 2px solid rgba(13, 148, 255, 1);
        color: #0d94ff;
        font-weight: bold;
      }
    }
  }
}

.tree {
  width: 100%;
  background-color: #fff;
  transition: all 0.5s;
  overflow: hidden;
  box-shadow: 0 0 2px 0 #8c939d;

  .data {
    width: 100%;
    margin-top: 8rem;
    height: 100%;
  }

  .option {
    width: 100%;
    .h(40);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 0 16rem;
    font-size: 14rem;
    font-weight: 300;
    color: #333333;
    line-height: 36rem;

    .all {
      cursor: pointer;

      img {
        // width: 16rem;
        // height: 16rem;
        margin-right: 8rem;
      }

      span {
        &:hover {
          color: rgba(13, 148, 255, 1);
        }
      }
    }

    > span {
      cursor: pointer;
      color: rgba(13, 148, 255, 1);
    }
  }
}

.nodes-tree {
  .w(260);
  height: 40px;
  margin-right: 8rem;
  background-color: #ffffff;
}

.report {
  margin-top: 24rem;
  .h(815);
}

.export {
  margin-left: 23rem;

  img {
    margin-right: 7rem;
  }

  span {
    font-size: 18rem;
    font-weight: 500;
    color: #333333;
  }
}

.btn {
  .w(96);
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background-color: #0d94ff;
  cursor: pointer;
  border-radius: 4rem;
  overflow: hidden;
  padding: 0px;
}

.per,
.next {
  background-color: #fff;
  font-size: 18rem;
  color: #666666;
  font-weight: 400;
  border: 1px solid rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #0d94ff;
    color: #ffffff;
  }
}

.el-button.is-plain:hover {
  background-color: #0d94ff !important;
  color: #ffffff !important;
  transition: 0s;
}

.el-button.is-active,
.el-button.is-plain:active,
.el-button.is-plain:focus {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #666666;
}

.el-button.is-disabled:hover {
  background-color: #ffffff !important;
  color: #c0c4cc !important;
  transition: 0s;
}

.per {
  // margin-left: 24rem;
}

.next {
  margin: 0 8rem;
}

.node-select,
.dateSelect {
  .w(240) !important;
  // .h(40) !important;
}

.node-select {
  .w(140) !important;
}
.el-radio {
  margin-right: 20rem;
}
.data-table {
  padding: 24rem;
  background-color: #fff;
  .w(1265);
  .h(968);

  .menu {
    margin-top: 24rem;

    .export {
      margin-left: 61rem;
    }

    .radio {
      margin-left: 24rem;

      .el-radio {
        margin-right: 20rem;
      }
    }
  }

  .title {
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
  }
}

.diagram {
  .w(1265);
  .h(618);
  margin-top: 8rem;
  background-color: #fff;
  padding-left: 24rem;

  // display: flex;
  .exetext {
    .w(728);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .exetext1 {
      display: flex;
      align-items: center;
    }
  }

  .left {
    width: 100%;
    .h(480);
  }

  .echarts {
    width: 100%;

    .left {
      width: 100%;
      .h(460);
    }

    .max-right {
      .w(282);
      // height: 380px;
      .h(460);
      margin-right: 24rem;

      .row-max {
        width: 100%;
        background-color: rgba(0, 43, 102, 0.02);
        // height: 88px;
        margin-bottom: 10px;

        .details {
          .w(188);
          height: 100%;
          padding: 12rem 0;

          span {
            margin-right: 8rem;
            color: rgba(13, 148, 255, 1);
            font-size: 16rem;

            &:first-child {
              color: #333333;
            }
          }
        }

        .max-name {
          height: 100%;
          .w(85);
          font-size: 18rem;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }

  .showMax {
    div.left {
      .w(920) !important;
    }
  }

  .tab {
    width: 100%;
    .h(438);
    margin-top: 25rem;
  }

  .content {
    margin-top: 10rem;

    .dateSelect {
      font-size: 18rem;
      color: #000000 !important;
      margin-right: 8rem;
    }

    .max {
      // .w(100);
      // margin-left: 127rem;
    }

    .hose {
      display: flex;
      align-items: center;
    }
  }

  .select1 {
    margin-right: 27rem;
    font-size: 18rem;
    font-weight: 400;
    color: #333333;
    padding-top: 23rem;
    border-top: 2px solid rgba(0, 0, 0, 0);
  }

  .select {
    > div {
      cursor: pointer;
      margin-right: 27rem;
      font-size: 18rem;
      font-weight: 400;
      color: #999999;
      padding-top: 21rem;
      border-top: 2px solid rgba(0, 0, 0, 0);

      &.active {
        color: #0d94ff;
        font-weight: bold;
        border-top: 2px solid #0d94ff;
      }
    }
  }
}

.real-data1 {
  .realLeft {
    padding: 24rem;
    .w(524);
    .h(342);
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

    .status {
      width: 100%;
      .h(220);
      margin-top: 57rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
    }

    .operation {
      .w(232);
      height: 100%;
      background: rgba(0, 43, 102, 0.04);
      display: flex;
      justify-content: center;
      align-items: center;

      .ovall {
        .h(127);
        .w(71);
        display: grid;
        text-align: center;

        .totalStatus {
          font-size: 18rem;
          font-weight: bold;
          color: #333333;
        }

        .boxStatus {
          font-size: 38rem;
          font-weight: bold;
          color: #68d86a;
        }

        .boxStatusOred {
          font-size: 38rem;
          font-weight: bold;
          color: #fd4238;
        }

        .boxStatusOBack {
          font-size: 38rem;
          font-weight: bold;
          color: #0d94ff;
        }
      }
    }

    .operation1 {
      .w(232);
      height: 100%;
      background: rgba(0, 43, 102, 0.04);
      display: flex;
      justify-content: center;
      align-items: center;

      .ovall {
        .h(127);
        .w(89);
        display: grid;
        text-align: center;

        .totalStatus {
          font-size: 18rem;
          font-weight: bold;
          color: #333333;
        }

        .boxStatus1 {
          // margin: auto;
          font-size: 18rem;

          .ax {
            width: 90%;
            margin: auto;
            display: flex;
            line-height: 28px;
            // justify-content: space-between;
            align-items: center;
            white-space: nowrap;
            font-size: 18rem;

            // p {
            //     font-size: 18rem;
            //     color: #333333;
            //     // white-space: nowrap
            // }

            .ax-2 {
              // display: flex;
              // justify-content: space-between;
              font-weight: 400;
              color: #0d94ff;
              font-size: 18rem;
              margin-right: 5rem;
            }
          }
        }
      }
    }
  }

  .realRight {
    .w(724);
    .h(342);
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    padding: 24rem;

    .foune-1 {
      display: flex;
      justify-content: space-between;

      // background-color: red;
      .tit-1 {
        display: flex;
        .w(170);
        justify-content: space-between;
        .h(69);
        font-size: 18rem;
        font-weight: 400;
        color: #333333;
      }
    }

    // .foune-2::-webkit-scrollbar {
    // width: 1px !important;
    // }
    .foune-2 {
      width: 100%;
      height: 80%;
      overflow-y: scroll;

      .oLi {
        width: 50%;
        height: 11%;
        background-color: #fff;
        // display: flex;
        border-top: rgba(0, 0, 0, 0.06) 1px solid;
        // align-items: center;
        float: left;

        .oli-Div {
          width: 100%;
          height: 100%;
          font-size: 18rem;
          display: flex;
          justify-content: space-between;
          padding-right: 35%;
        }
      }
    }
  }

  .tit {
    font-size: 18rem;
    color: #333333;
    font-weight: bold;
    position: relative;
  }
}

.real-data {
  background-color: #ffffff;
  padding: 24rem;
  .h(342);

  .total-data {
    margin-top: 23rem;
    background: rgba(0, 43, 102, 0.04);
    border-radius: 4px;
    // padding-left: 8rem;
    line-height: 36rem;

    font-size: 18rem;
    font-weight: 400;
    color: #333333;

    .total-item {
      background-color: #fff;
      height: 100%;
    }

    .total-data-close {
      margin-left: 24rem;
      color: #fd4238;
      font-weight: bold;
    }

    .total-data-open {
      margin-left: 24rem;
      color: #68d86a;
      font-weight: bold;
    }
  }

  .PowerQuality-none {
    .w(280) !important;

    .val {
      .w(145) !important;
    }

    .key {
      width: auto !important;
      margin-left: 25rem;
      margin-right: 32rem;
    }
  }

  .data {
    .w(395);

    .details {
      .h(132);
      justify-content: space-between;
      margin-top: 23rem;

      .row {
        margin-bottom: 18rem;
      }

      .active {
        span {
          color: #fd4238;
        }
      }

      .key,
      .val {
        font-size: 14rem;
        color: #333333;
        font-weight: 400;
      }

      .key {
        .w(120);
        /*margin-right: 4rem;*/
      }

      .val {
        color: #0d94ff;
        .w(263);

        span {
          display: inline-block;
          width: 25%;
        }
      }
    }
  }

  .tit {
    font-size: 18rem;
    color: #333333;
    font-weight: bold;
    position: relative;

    .location-right {
      .w(492);
      .h(236);
      position: absolute;
      right: 69rem;
      background-color: red;
      padding: 36rem 0 0 38rem;
      background: rgba(0, 43, 102, 0.04);

      .location-and {
        display: flex;
        align-items: center;
        height: 34rem;

        .location-img {
          width: 34rem;
          height: 34rem;
          margin-right: 5px;
        }

        img {
          width: 34rem;
          height: 34rem;
        }
      }

      .location-title {
        // font-size: 24px;

        font-size: 28rem;
        font-weight: bold;
        color: #68d86a;

        line-height: 30px;
      }

      .location-orag {
        font-size: 28rem;
        font-weight: bold;
        color: #f5aa00;

        line-height: 30px;
      }

      .location-item {
        margin-top: 35rem;
        .w(420);
        height: 63px;
        font-size: 16rem;
        font-weight: 400;
        color: #999999;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        /*这个参数根据需求来决定要不要*/
      }
    }
  }

  .name {
    font-size: 18rem;
    color: #333333;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding-bottom: 8rem;
    margin-top: 20rem;
    padding-left: 17rem;
  }
}

.Loopst {
  width: 475rem;
}

.breaker {
  display: flex;
  width: 100%;
  height: 100%;
  // background-color: rgba(0, 43, 102, 0.04);
  padding-left: 8rem;

  span {
    font-size: 18rem;
    font-weight: bold;
  }

  .k {
    color: #333333;
    margin-right: 24rem;
  }

  .v {
    color: red;
  }

  .Handcart {
    color: #0d94ff;
  }

  .sate {
    padding-left: 325rem;
  }
}

.ored {
  margin-left: 24rem;
  color: #fd4238;
  font-weight: bold;
}

.oglad {
  margin-left: 24rem;
  color: #68d86a;
  font-weight: bold;
}

.obalck {
  color: #0d94ff;
  font-weight: bold;
}
</style>
